import moment from 'moment'

export default {
  getStatus (service) {
    if (typeof service.status !== 'undefined') {
      if (service.status === 'PENDING') {
        return {
          color: 'warning',
          icon: 'fa-warning',
          text: 'En attente de signature'
        }
      } else if (service.status === 'PAUSE') {
        return {
          color: 'warning',
          icon: 'fa-warning',
          text: 'En pause'
        }
      } else if (service.status === 'STOPPED' || service.status === 'FINISHED') {
        return {
          color: 'danger',
          icon: 'fa-times',
          text: 'Arrété'
        }
      }
    }

    if (typeof service.start_at !== 'undefined') {
      let startedSinceDays = moment(service.start_at.date).diff(moment(), 'days') * -1
      if (startedSinceDays < 0) {
        return {
          color: 'warning',
          icon: 'fa-warning',
          text: 'Débute dans ' + startedSinceDays + ' jour(s)'
        }
      }
    }

    if (typeof service.end_at !== 'undefined') {
      let endsInDays = moment(service.end_at.date).diff(moment(), 'days')
      if (endsInDays < 0) {
        return {
          color: 'danger',
          icon: 'fa-times',
          text: 'Terminé ' + moment(service.end_at.date).fromNow()
        }
      } else if (endsInDays < 30) {
        return {
          color: 'danger',
          icon: 'fa-times',
          text: 'Termine dans ' + endsInDays + ' jour(s)'
        }
      } else if (endsInDays < 60) {
        return {
          color: 'warning',
          icon: 'fa-warning',
          text: 'Termine dans ' + endsInDays + ' jour(s)'
        }
      }
    }

    if (typeof service.meta.quote_last_received_at !== 'undefined' && typeof service.meta.quote_last_received_at !== 'undefined') {
      if (service.quote_last_received_at === null) {
        return {
          color: 'danger',
          icon: 'fa-times',
          text: 'Rien reçu depuis le début du service.'
        }
      }

      let lastInDays = moment().diff(moment(service.quote_last_received_at), 'days')
      if (lastInDays > 30) {
        return {
          color: 'warning',
          icon: 'fa-warning',
          text: 'Dernier contact / rendez-vous reçu il y a ' + lastInDays + ' jour(s)'
        }
      } else if (lastInDays > 60) {
        return {
          color: 'danger',
          icon: 'fa-times',
          text: 'Dernier contact / rendez-vous reçu il y a ' + lastInDays + ' jour(s)'
        }
      }
    }

    return {
      color: 'success',
      icon: 'fa-check',
      text: 'En fonctionnement'
    }
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/service.js